import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TaxonomyItemType } from './types';
import TaxonomyItem from './TaxonomyItem';

const TaxonomyTree: React.FC = () => {
  const [taxonomy, setTaxonomy] = useState<TaxonomyItemType[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [newItemName, setNewItemName] = useState('');
  const [editingItem, setEditingItem] = useState<TaxonomyItemType | null>(null);

  useEffect(() => {
    fetchTaxonomy();
  }, []);

  const fetchTaxonomy = async () => {
    const response = await axios.get<{ data: TaxonomyItemType[] }>('/admin/taxonomy/all');
    setTaxonomy(response.data.data);
  };

  const addItem = async () => {
    const formData = new FormData();
    formData.append('name', newItemName);

    await axios.post('/admin/taxonomy/create', formData);
    setNewItemName('');
    setShowModal(false);
    fetchTaxonomy();
  };

  const updateParent = async (itemId: number, parentId: number | null) => {
    const formData = new FormData();
    formData.append('parent_id', parentId === null ? '-1' : parentId.toString());

    await axios.post(`/admin/taxonomy/assign_parent/${itemId}/${parentId}`, formData);
    fetchTaxonomy();
  };

  const saveEdit = async () => {
    if (!editingItem) return;

    const formData = new FormData();
    formData.append('name', editingItem.name);

    await axios.post(`/admin/taxonomy/update/${editingItem.id}`, formData);
    setEditingItem(null);
    fetchTaxonomy();
  };

  const editItem = (item: TaxonomyItemType) => {
    setEditingItem(item);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col">
          <button className="btn btn-primary mb-3" onClick={() => setShowModal(true)}>Add Taxonomy</button>
          <div className="taxonomy-tree">
          {taxonomy
            .filter(item => item.parent_id === null) // Only render root-level items here
            .map(rootItem => (
              <TaxonomyItem
                key={rootItem.id}
                item={rootItem}
                taxonomy={taxonomy}
                updateParent={updateParent}
                editItem={editItem}
                depth={0} // Root items have depth 0
              />
            ))}
        </div>
        </div>
      </div>

      {/* Add Item Modal */}
      {showModal && (
        <div className="modal d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Taxonomy Item</h5>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Item name"
                  value={newItemName}
                  onChange={(e) => setNewItemName(e.target.value)}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={addItem}>Add</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Edit Item Modal */}
      {editingItem && (
        <div className="modal d-block">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Taxonomy Item</h5>
                <button className="btn-close" onClick={() => setEditingItem(null)}></button>
              </div>
              <div className="modal-body">
                <input
                  type="text"
                  className="form-control mb-3"
                  value={editingItem.name}
                  onChange={(e) => setEditingItem({ ...editingItem, name: e.target.value })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditingItem(null)}>Cancel</button>
                <button className="btn btn-primary" onClick={saveEdit}>Save</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TaxonomyTree;
